<template>
    <div class="main">
        <c-panel title="MODELOS DE DOCUMENTO" titleIcon="fas fa-file-alt">
            <el-row :gutter="10" class="u-mb-10">
                <el-col :xs="24" :sm="14">
                    <el-input v-model="filtro.busca" placeholder="Buscar por nome" @keyup.enter.native="load" clearable></el-input>
                </el-col>
                <el-col :xs="24" :sm="10" class="u-text-right">
                    <el-button @click="load" icon="el-icon-search">FILTRAR</el-button>
                    <router-link to="/admin/modelo-documento/cadastro"><el-button type="primary" icon="el-icon-plus">NOVO MODELO</el-button></router-link>
                </el-col>
            </el-row>

            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width:70px;">Cod</th>
                        <th>Nome</th>
                        <th style="width:140px;">Categoria</th>
                        <th style="width:90px;">Papel</th>
                        <th style="width:90px;">Situação</th>
                        <th style="width:240px;" class="u-text-center">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="m in items" :key="m.id">
                        <td>{{ m.id }}</td>
                        <td>{{ m.nome }}</td>
                        <td>{{ m.categoria || '—' }}</td>
                        <td>{{ m.papel }}</td>
                        <td>
                            <el-tag :type="m.situacao ? 'success' : 'info'" size="mini">{{ m.situacao ? 'Ativo' : 'Inativo' }}</el-tag>
                        </td>
                        <td class="u-text-center">
                            <router-link :to="'/admin/modelo-documento/edit/' + m.id">
                                <el-button size="mini" type="info" plain icon="el-icon-edit"></el-button>
                            </router-link>
                            <el-button size="mini" type="primary" plain icon="el-icon-printer" @click="abrirImprimir(m)">IMPRIMIR</el-button>
                            <el-button size="mini" type="danger" plain icon="el-icon-delete" @click="excluir(m.id)"></el-button>
                        </td>
                    </tr>
                    <tr v-if="!items.length">
                        <td colspan="6" class="u-text-center" style="padding: 20px; color: #909399;">Nenhum modelo.</td>
                    </tr>
                </tbody>
            </table>

            <el-dialog title="Imprimir modelo" :visible.sync="modalImprimirVisivel" width="500px">
                <p v-if="modeloAtual"><strong>{{ modeloAtual.nome }}</strong></p>
                <el-form label-position="top">
                    <el-form-item label="Aluno (opcional)">
                        <el-select v-model="contexto.aluno_id" filterable remote :remote-method="buscarAluno"
                            :loading="loadAluno" placeholder="Digite o nome..." clearable style="width:100%;">
                            <el-option v-for="a in alunosBusca" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Servidor (opcional)">
                        <el-select v-model="contexto.servidor_id" filterable remote :remote-method="buscarServidor"
                            :loading="loadServidor" placeholder="Digite o nome..." clearable style="width:100%;">
                            <el-option v-for="s in servidoresBusca" :key="s.id" :label="s.nome" :value="s.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="modalImprimirVisivel = false">CANCELAR</el-button>
                    <el-button type="primary" @click="imprimir">GERAR PDF</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>

<script>
export default {
    data () {
        return {
            items: [], filtro: { busca: '' },
            modalImprimirVisivel: false, modeloAtual: null,
            contexto: { aluno_id: null, servidor_id: null },
            alunosBusca: [], servidoresBusca: [],
            loadAluno: false, loadServidor: false
        }
    },
    mounted () { this.load() },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        load () {
            this.$axios.post(`${this.baseUrl()}/api/modelo-documento/getAllPaginate`, this.filtro, this.$store.getters.getHeaderAuth)
                .then(r => { this.items = (r.data && r.data.data) ? r.data.data : (r.data || []) })
                .catch(e => this.$store.commit('throwException', e))
        },
        excluir (id) {
            this.$confirm('Excluir modelo?', 'Confirmar', { type: 'warning' }).then(() => {
                this.$axios.delete(`${this.baseUrl()}/api/modelo-documento/delete/${id}`, this.$store.getters.getHeaderAuth).then(() => this.load())
            }).catch(() => {})
        },
        abrirImprimir (m) {
            this.modeloAtual = m
            this.contexto = { aluno_id: null, servidor_id: null }
            this.alunosBusca = []; this.servidoresBusca = []
            this.modalImprimirVisivel = true
        },
        buscarAluno (q) {
            if (!q || q.length < 2) return
            this.loadAluno = true
            this.$axios.post(`${this.baseUrl()}/api/aluno/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
                .then(r => { this.alunosBusca = r.data || []; this.loadAluno = false })
                .catch(() => { this.loadAluno = false })
        },
        buscarServidor (q) {
            if (!q || q.length < 2) return
            this.loadServidor = true
            this.$axios.post(`${this.baseUrl()}/api/servidor/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
                .then(r => { this.servidoresBusca = r.data || []; this.loadServidor = false })
                .catch(() => { this.loadServidor = false })
        },
        imprimir () {
            const payload = {
                ...this.contexto,
                instituicao_id: this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null
            }
            this.$axios.post(`${this.baseUrl()}/api/modelo-documento/imprimir/${this.modeloAtual.id}`, payload, {
                ...this.$store.getters.getHeaderAuth, responseType: 'blob'
            }).then(r => {
                const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }))
                window.open(url, '_blank')
                this.modalImprimirVisivel = false
            }).catch(e => this.$store.commit('throwException', e))
        }
    }
}
</script>
